var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.9 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M67.4 200v-91.2H98l4.6-35.6H67.4V50.5c0-10.3 2.9-17.3 17.6-17.3h18.8V1.4C100.6 1 89.4 0 76.4 0 49.3 0 30.7 16.6 30.7 47v26.2H0v35.6h30.7V200z"
  })));
};
export default SvgFacebook;